import * as actionTypes from './actionTypes'
import { LOGOUT_USER } from '../user/actionTypes'

const initialState = {
    offersList: { offers: [], total: 0, pageSize: 0, error: null, loading: false },
    offerList: { offer: null, error: null, loading: false },
    newOffer: { offer: null, error: null, loading: false },
    updateOffer: { offer: null, error: null, loading: false },
    deleteOffer: { offer: null, error: null, loading: false },
    uploadImageOffer: { imageUrl: null, error: null, loading: false },
    deleteImageOffer: { success: false, error: null, loading: false },
}

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_OFFERS:
            return {
                ...state,
                offersList: {
                    ...state.offersList,
                    error: null,
                    loading: true,
                }
            }
        case actionTypes.FETCH_OFFERS_SUCCESS:
            return {
                ...state,
                offersList: {
                    offers: action.payload.offers,
                    total: action.payload.total,
                    pageSize: action.payload.pageSize,
                    error: null,
                    loading: false,
                }
            }
        case actionTypes.FETCH_OFFERS_FAILURE:
            return {
                ...state,
                offersList: {
                    offers: [],
                    total: 0,
                    pageSize: 0,
                    error: action.payload.error,
                    loading: false,
                }
            }
        case actionTypes.RESET_OFFERS:
            return { ...state, offersList: initialState.offersList }

        case actionTypes.FETCH_OFFER:
            return {
                ...state,
                offerList: {
                    ...state.offerList,
                    error: null,
                    loading: true,
                }
            }
        case actionTypes.FETCH_OFFER_SUCCESS:
            return {
                ...state,
                offerList: {
                    offer: action.payload.offer,
                    error: null,
                    loading: false,
                }
            }
        case actionTypes.FETCH_OFFER_FAILURE:
            return {
                ...state,
                offerList: {
                    offer: {},
                    error: action.payload.error,
                    loading: false,
                }
            }
        case actionTypes.RESET_OFFER:
            return { ...state, offerList: initialState.offerList }

        case actionTypes.CREATE_OFFER:
            return {
                ...state,
                newOffer: {
                    offer: null,
                    error: null,
                    loading: true
                }
            }

        case actionTypes.CREATE_OFFER_SUCCESS:
            return {
                ...state,
                newOffer: {
                    offer: action.payload.offer,
                    error: null,
                    loading: false
                }
            }

        case actionTypes.CREATE_OFFER_FAILURE:
            return {
                ...state,
                newOffer: {
                    offer: null,
                    error: action.payload.error,
                    loading: false
                }
            }

        case actionTypes.RESET_CREATE_OFFER:
            return { ...state, newOffer: initialState.newOffer }


        case actionTypes.UPLOAD_IMAGE_OFFER:
            return { ...state, uploadImageOffer: { imageUrl: null, error: null, loading: true } }

        case actionTypes.UPLOAD_IMAGE_OFFER_SUCCESS:
            return { ...state, uploadImageOffer: { imageUrl: action.payload.imageUrl, error: null, loading: false } }

        case actionTypes.UPLOAD_IMAGE_OFFER_FAILURE:
            return { ...state, uploadImageOffer: { imageUrl: null, error: action.payload.error, loading: false } }

        case actionTypes.RESET_UPLOAD_IMAGE_OFFER:
            return { ...state, uploadImageOffer: initialState.uploadImageOffer }


        case actionTypes.DELETE_IMAGE_OFFER:
            return { ...state, deleteImageOffer: { success: false, error: null, loading: true } }

        case actionTypes.DELETE_IMAGE_OFFER_SUCCESS:
            return { ...state, deleteImageOffer: { success: true, error: null, loading: false } }

        case actionTypes.DELETE_IMAGE_OFFER_FAILURE:
            return { ...state, deleteImageOffer: { success: false, error: action.payload.error, loading: false } }

        case actionTypes.RESET_DELETE_IMAGE_OFFER:
            return { ...state, deleteImageOffer: initialState.deleteImageOffer }


        case actionTypes.UPDATE_OFFER:
            return {
                ...state,
                updateOffer: {
                    ...state.updateOffer,
                    error: null,
                    loading: true,
                }
            }
        case actionTypes.UPDATE_OFFER_SUCCESS:
            return {
                ...state,
                updateOffer: {
                    offer: action.payload.offer,
                    error: null,
                    loading: false,
                }
            }
        case actionTypes.UPDATE_OFFER_FAILURE:
            return {
                ...state,
                updateOffer: {
                    offer: null,
                    error: action.payload.error,
                    loading: false,
                }
            }
        case actionTypes.RESET_UPDATE_OFFER:
            return { ...state, updateOffer: initialState.updateOffer }

        case actionTypes.DELETE_OFFER:
            return { ...state, deleteOffer: { offer: null, error: null, loading: true } }

        case actionTypes.DELETE_OFFER_SUCCESS:
            return { ...state, deleteOffer: { offer: action.payload.offer, error: null, loading: false } }

        case actionTypes.DELETE_OFFER_FAILURE:
            return { ...state, deleteOffer: { offer: null, error: action.payload.error, loading: false } }

        case actionTypes.RESET_DELETE_OFFER:
            return { ...state, deleteOffer: initialState.deleteOffer }


        case LOGOUT_USER:
            return initialState;

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/offer/reducer.js